// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails";
import { Application } from "@hotwired/stimulus"

import "trix"
import "@rails/actiontext"

import OwnerAutocompleteController from "./controllers/owner_autocomplete_controller"
import TenantAutocompleteController from "./controllers/tenant_autocomplete_controller"
import PropertyAutocompleteController from "./controllers/property_autocomplete_controller"
import ZipcodeAutocompleteController from "./controllers/zipcode_autocomplete_controller"
import AccountAutocompleteController from "./controllers/account_autocomplete_controller"
import PayToOwnerCalculatorController from "./controllers/pay_to_owner_calculator_controller"

window.Stimulus = Application.start()
Stimulus.register("owner-autocomplete", OwnerAutocompleteController)
Stimulus.register("tenant-autocomplete", TenantAutocompleteController)
Stimulus.register("property-autocomplete", PropertyAutocompleteController)
Stimulus.register("zipcode-autocomplete", ZipcodeAutocompleteController)
Stimulus.register("account-autocomplete", AccountAutocompleteController)
Stimulus.register("pay-to-owner-calculator", PayToOwnerCalculatorController)

// Custom Turbo Confirm Modal matching the app's Bootstrap theme
Turbo.config.forms.confirm = (message, element) => {
  let dialog = document.getElementById("turbo-confirm-modal");
  
  if (!dialog) {
    dialog = document.createElement("div");
    dialog.id = "turbo-confirm-modal";
    dialog.className = "modal fade";
    dialog.tabIndex = -1;
    dialog.innerHTML = `
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 shadow-lg rounded-4">
          <div class="modal-header border-0 pb-0">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body py-4 text-center">
            <div class="d-inline-flex align-items-center justify-content-center bg-danger bg-opacity-10 text-danger rounded-circle mb-3" style="width: 80px; height: 80px;">
                <i class="bi bi-trash fs-1"></i>
            </div>
            <h4 class="fw-bold mb-2 text-dark">Confirmar Acción</h4>
            <p class="mb-0 fs-6 text-muted" id="turbo-confirm-message"></p>
          </div>
          <div class="modal-footer border-0 pt-0 pb-4 justify-content-center gap-2">
            <button type="button" class="btn btn-light px-4 py-2 rounded-pill fw-medium" data-bs-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-danger px-4 py-2 rounded-pill fw-medium shadow-sm" id="turbo-confirm-accept">Eliminar</button>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(dialog);
  }

  document.getElementById("turbo-confirm-message").textContent = message;
  const modal = new window.bootstrap.Modal(dialog);
  modal.show();

  return new Promise((resolve) => {
    const acceptBtn = document.getElementById("turbo-confirm-accept");
    
    // Clean up previous event listeners by cloning the node
    const newAcceptBtn = acceptBtn.cloneNode(true);
    acceptBtn.parentNode.replaceChild(newAcceptBtn, acceptBtn);
    
    newAcceptBtn.addEventListener("click", () => {
      resolve(true);
      modal.hide();
    });

    const hiddenHandler = () => {
      resolve(false);
      dialog.removeEventListener("hidden.bs.modal", hiddenHandler);
    };

    dialog.addEventListener("hidden.bs.modal", hiddenHandler);
  });
};